import { Grid, TextField, Typography, IconButton } from "@mui/material";
import React, { useState } from "react"
import PrintIcon from '@mui/icons-material/Print';

interface Props{
    size:"A4" | "ticket",
    name:string
}

export const DocumentPDF:React.FC<Props> = (props) => {
    const printRef = React.useRef<HTMLDivElement>(null);
    
    async function savePDF(){
        const element = printRef.current;
        if(element){
            document.title=props.name;
            window.print();
            // var printWindow = window.open('', '', 'height=400,width=800');
            // if(printWindow){
            //     printWindow.document.write('<html><head><title>DIV Contents</title>');
            //     printWindow.document.write('</head><body >');
            //     printWindow.document.write(ReactDOMServer.renderToString(document.getElementById("print").innerHTML));
            //     printWindow.document.write('</body></html>');
            //     printWindow.document.close();
            //     printWindow.print();
            // }
        //     var doc = new jsPDF('p', 'mm', [720, 1018]);
            
            
        //    // Convert HTML to PDF in JavaScript
        //    doc.html(element, {
                
        //         callback: function(doc) {
        //             const pageCount = doc.getNumberOfPages();
        //             doc.setFont("Montserrat-Regular");
        //             for(let i = 1; i <= pageCount; i++) {
        //                 doc.setPage(i);
        //                 const pageSize = doc.internal.pageSize;
        //                 const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
        //                 const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

        //                 // const header = `Header for Page ${i}`;
        //                 // doc.setFontSize(12);
        //                 // doc.text(header, pageWidth / 2 - (doc.getTextWidth(header) / 2), 10);

                        
        //                 const footer = `Page ${i} of ${pageCount}`;
        //                 doc.text(footer, pageWidth / 2 - (doc.getTextWidth(footer) / 2), pageHeight - 15, { baseline: 'bottom' });

        //             }
        //             doc.save(props.name+".pdf");
        //         },
        //         x: 0,
        //         y: 0,
        //         margin: [100, 0, 100, 60],
        //         autoPaging: 'text',
        //         width: 720, //target width in the PDF document
        //         windowWidth: 900 //window width in CSS pixels
        //     });
        }
        else{
            console.log("No ref")
        }
    }

      
    if(props.size === "A4"){
        return(
            <div style={{overflow:'scroll'}}>
                
                <Grid item xs={12} style={{textAlign:'right'}}>
                    <IconButton 
                        id="button_print" 
                        onClick={savePDF}
                        color="primary"
                        sx={{
                            backgroundColor: 'primary.main',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: 'primary.dark',
                            },
                            borderRadius: 2,
                            padding: 1.5
                        }}
                    >
                        <PrintIcon />
                    </IconButton>
                </Grid>
                
                <Grid container xs={12}>
                    <div id="print" ref={printRef} style={{width:'100%', fontFamily: "Montserrat-Regular"}}>
                    <style>
                        {`
                        @media print {
                            #button_print, #close-modal {
                                display: none;
                            }
                            #header, #menu, #sidebar { 
                                height: 1px; 
                                display: none;
                            }
                            
                            /* Page break controls only */
                            .page-break-before { page-break-before: always !important; }
                            .page-break-after { page-break-after: always !important; }
                            .page-break-avoid { page-break-inside: avoid !important; }
                            
                            /* Keep sections together when possible */
                            .pdf-section { page-break-inside: avoid !important; }
                            .pdf-section-large { page-break-inside: auto !important; }
                            .pdf-signature-area { page-break-inside: avoid !important; }
                            .pdf-keep-together { page-break-inside: avoid !important; }
                        }
                        `}
                    </style>
                        {
                            props.children
                        }
                    </div>
                </Grid>
            </div>
        )
    }
    else{
        return null;
    }
}
